import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetWhiteListDeviceColumns from "./ColumnDefinition/WhiteListDeviceColumn/GetWhiteListDeviceColumns";
import { mapWhiteListDeviceToDataTable as mapData } from "./Helper";

const WhiteListDeviceTable = ({ data, handleOpenPopup, status }) => {
  const columns = GetWhiteListDeviceColumns({
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={450} />
  );
};

export default WhiteListDeviceTable;
